import gql from "graphql-tag";

export const MY_DOCUMENTS_DELETE_DOCUMENT = gql`
  mutation deleteMyDocument($_id: String!) {
    deleteMyDocument(_id: $_id)
  }
`;
